<template>
  <div>
    <q-dialog v-model="dialog" persistent maximized>
      <q-card>
        <q-card-section class="row items-center q-pa-sm bg-primary text-white">
          <div class="text-h6">Responder pesquisa</div>
          <q-space />
          <q-btn icon="close" flat round dense @click="dialog = false" />
        </q-card-section>
        <q-card-section v-if="pesquisa._id">
          <div class="col-12">
            <q-linear-progress color="primary" indeterminate v-if="loading" />
            <q-stepper
              v-model="step"
              ref="stepper"
              animated
              active-color="primary"
              vertical
            >
              <q-step
                v-for="(pergunta, idx) of pesquisa.perguntas"
                :key="idx"
                :name="idx +1"
                :prefix="idx +1"
                title=""
              >
                <q-card-section class="q-pa-none">
                  <strong>{{pergunta.pergunta}}</strong>
                </q-card-section>
                <q-card-section class="q-pa-none">
                  <div class="col-12 q-pa-none">
                    <q-list class="q-pa-none">
                      <q-input
                        label="Sua resposta"
                        v-if="pergunta.tipo === 'text'"
                        class="q-pa-none"
                        v-model="pergunta.resposta"
                      />
                      <q-item
                        class="q-pa-none"
                        tag="label"
                        v-ripple
                        v-for="(opcao, idx) of pergunta.opcoes"
                        :key="idx"
                      >
                        <q-item-section avatar>
                          <q-radio
                            v-if="pergunta.tipo === 'radio'"
                            class="q-pa-none"
                            v-model="pergunta.resposta"
                            :val="opcao"
                            color="teal"
                          />
                          <q-checkbox
                            v-if="pergunta.tipo === 'check'"
                            class="q-pa-none"
                            v-model="pergunta.resposta"
                            :val="opcao"
                            color="teal"
                          />
                        </q-item-section>
                        <q-item-section v-if="pergunta.tipo !== 'text'">
                          <q-item-label>{{opcao}}</q-item-label>
                        </q-item-section>
                      </q-item>
                    </q-list>
                  </div>
                </q-card-section>
                <q-stepper-navigation>
                  <q-btn color="primary" :disable="disableNextBtn(pergunta)" @click="step = step +1" label="Próxima" v-if="step < pesquisa.perguntas.length"/>
                  <q-btn color="primary" label="Finalizar" :disable="disableNextBtn(pergunta)" @click="responder" v-if="step === pesquisa.perguntas.length" />
                  <q-btn flat @click="step = step -1" color="primary" label="Voltar" class="q-ml-sm" v-if="step > 1" />
                </q-stepper-navigation>
              </q-step>

            </q-stepper>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { getPesquisa, salvarRespostas } from '../../services/pesquisa'
export default {
  props: {
    idPesquisa: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      dialog: false,
      pesquisa: {},
      step: 1
    }
  },
  mounted () {

  },
  methods: {
    open () {
      this.step = 1
      this.getPesquisa()
      this.dialog = true
    },

    async responder () {
      try {
        const respostas = this.prepararParaEnvio()
        await salvarRespostas({ respostas })
        this.dialog = false
        this.$q.notify({
          color: 'green',
          position: 'top-right',
          icon: 'check',
          message: 'Obrigado por responder a pesquisa!'
        })
        this.$emit('on-save')
      } catch (error) {
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível salvar a pesquisa no momento. Tente daqui a pouco!'
        })
      }
    },

    async getPesquisa () {
      try {
        this.loading = true
        const response = await getPesquisa({ idPesquisa: this.idPesquisa })
        const perguntas = response.perguntas.map(x => {
          return { ...x, resposta: x.tipo === 'check' ? [] : '' }
        })
        this.pesquisa = {
          ...response,
          perguntas
        }
      } catch (error) {
        console.error(error)
        this.dialog = false
        this.$q.notify({
          color: 'negative',
          position: 'top-right',
          icon: 'report_problem',
          message: 'Não foi possível buscar a pesquisa no momento. Tente daqui a pouco!'
        })
      } finally {
        this.loading = false
      }
    },

    disableNextBtn (pergunta) {
      if (pergunta.tipo === 'check') {
        return (pergunta.required && !pergunta.resposta.length)
      }
      return (pergunta.required && !pergunta.resposta)
    },

    prepararParaEnvio () {
      return this
        .pesquisa
        .perguntas
        .map(pergunta => {
          if (pergunta.tipo === 'check' && pergunta.resposta.length) {
            return pergunta.resposta.map(resposta => {
              return { ...pergunta, resposta }
            })
          }
          return [pergunta]
        })
        .reduce((previous, current) => [...previous, ...current], [])
        .map(pergunta => {
          return {
            pesquisa: { _id: this.pesquisa._id },
            pergunta: { _id: pergunta._id },
            resposta: pergunta.resposta
          }
        })
        .filter(x => x.resposta)
    }
  }
}
</script>